import { AppRoutingService } from '@core/app-routing.service';
import { NavigationMenuItem } from '@models/navigation-menu-item';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, forkJoin } from 'rxjs';

export enum ParentsSubNavMenuId {
  ClassUpdates = 'parent-subnav-class-updates',
  Resources = 'parent-subnav-resources',
  ProgressReports = 'parent-subnav-progress-reports',
  Assignments= 'parent-subnav-assignments',
  StudentLogin = 'parent-subnav-student-login',
}

export function buildParentsSubnav(
  appRoutingService: AppRoutingService,
  subNavMenuItems: BehaviorSubject<NavigationMenuItem[]>,
  translateService: TranslateService,
  studentId: string,
  classroomId: string,
  showCurrentAssignmentsNavLink: boolean,
  isSuperKidsClassroom: boolean,
): void {
  const newMenus: NavigationMenuItem[] = [];

  if (studentId && classroomId) {
    forkJoin({
      classUpdates: translateService.get('parent-subnav-classUpdatesLink'),
      resources: translateService.get('parent-subnav-resourceRepositoryLink'),
      progressReports: translateService.get('parent-subnav-progressReportsLink'),
      assignments: translateService.get('parent-subnav-studentAssignmentsLink'),
      studentPortal: translateService.get('parent-subnav-zbpForStudentsLink'),
    }).subscribe((translatedMenus) => {
      newMenus.push(
        {
          id: ParentsSubNavMenuId.ClassUpdates,
          weight: 0,
          route: appRoutingService.getParentClassUpdatesRoute(studentId, classroomId).toString(),
          label: translatedMenus.classUpdates,
        },
        {
          id: ParentsSubNavMenuId.ProgressReports,
          weight: 2,
          route: appRoutingService.getParentProgressReportsRoute(studentId, classroomId).toString(),
          label: translatedMenus.progressReports,
        },
        {
          id: ParentsSubNavMenuId.StudentLogin,
          weight: 4,
          route: appRoutingService.getParentStudentLoginRoute(studentId, classroomId).toString(),
          label: translatedMenus.studentPortal,
        },
      );

      if (isSuperKidsClassroom) {
        newMenus.push(
          {
            id: ParentsSubNavMenuId.Resources,
            weight: 1,
            route: appRoutingService.getParentResourcesRoute(studentId, classroomId).toString(),
            label: translatedMenus.resources,
          },
        );
      }

      if (showCurrentAssignmentsNavLink) {
        newMenus.push(
          {
            id: ParentsSubNavMenuId.Assignments,
            weight: 3,
            route: appRoutingService.getParentAssignmentsRoute(studentId, classroomId).toString(),
            label: translatedMenus.assignments,
          },
        );
      }

      newMenus.sort((a, b) => a.weight - b.weight);
      subNavMenuItems.next(newMenus);
    });
  }
}

